import { DoseUnit } from "$global-providers/rxdb-provider/collections/prescription";

export const clinicalProductFormToDoseUnitMap = {
  // capsule
  "80f75ba1-13bf-4a4a-9dd9-4953a21617ae": DoseUnit.Capsule,
  // chewable tablet
  "15bc9280-5f1f-44ec-a6d0-2e3b28dce563": DoseUnit.Tablet,
  // cream
  "01d547fd-a766-4ab1-8570-6d5ccb6c69e8": DoseUnit.Application,
  // dispersible tablet
  "1e52af4e-5eb5-458c-9d56-33913fcb4c6f": DoseUnit.Tablet,
  // ear drops
  "8d98dd0e-7610-43ca-aa48-1ce493451a5f": DoseUnit.Drop,
  // enema
  "6acc921e-33f5-4a36-b5b2-f20db2777cc2": DoseUnit.Application,
  // eye drops
  "a952243a-c990-4a20-a826-be70ce201bc7": DoseUnit.Drop,
  // eye/ear drops
  "8f353093-b77b-4bfd-bd84-deb28d14b2f8": DoseUnit.Drop,
  // eye ointment
  "997cb105-5bf3-423e-9117-1c45747cbba9": DoseUnit.Application,
  // inhaler
  "bb577505-462f-4232-9f74-8ea742d54114": DoseUnit.Puff,
  // nasal drops
  "e59655cc-22b8-475b-940e-f455b7ab9479": DoseUnit.Drop,
  // ointment
  "ef6893b6-a3ed-45b2-ae74-4aaba7ee559d": DoseUnit.Application,
  // oral drops
  "be07e314-a22d-4096-803e-d8ec2ec4b16c": DoseUnit.Drop,
  // patch
  "f7311c4d-b8d6-49e3-bee7-96b9f663acdf": DoseUnit.Patch,
  // powder for injection
  "98f9381b-abd1-46a0-bf62-226735133d05": DoseUnit.Mg,
  // syrup
  "3fd2948d-bf2b-4d48-8f4d-1a4e8cd7b7fb": DoseUnit.Ml,
  // tablet
  "cc99f34e-a933-41a3-b732-10a7b09d1e94": DoseUnit.Tablet,
  // lotion
  "4a3f8c68-ee98-4b2c-8da0-bf351b7a45b2": DoseUnit.Application,
  // oral suspension
  "38872de6-6ee2-432c-94b2-6ffdff39f83d": DoseUnit.Ml,
  // granules
  "3278440c-d4ea-49d7-bb7e-5737c0fd0ab7": DoseUnit.Sachet,
  // modified-release capsule
  "891b342e-2d53-4bf6-8372-d88ed365a8c6": DoseUnit.Capsule,
  // modified-release tablet
  "d37694ba-7479-4fc7-b447-2b91ed3b1466": DoseUnit.Tablet,
  // oral gel
  "5ea964ce-cb59-4e51-a7f8-f4ccb3569b77": DoseUnit.Application,
  // topical gel
  "a1445e2c-8295-48b5-8eed-012720e29637": DoseUnit.Application,
  // suppository
  "e11e7073-bcda-4442-805e-ebaf3ca21973": DoseUnit.Suppository,
  // pessary
  "e3adf6e2-a58e-4e71-b155-c4e2d9cb8bb6": DoseUnit.Pessary,
  // nebuliser solution
  "0e7db31a-c18e-4162-8dc7-2d9b6303e7ef": DoseUnit.Dose,
  // solution for injection
  "29ca2545-40d5-471f-ba7a-b3b35b6ab34f": DoseUnit.Mg,
  // implant
  "a3913842-4a90-448f-93d6-01bac26f2013": DoseUnit.Device,
  // nasal spray
  "10d3a2f7-4c0e-4dad-9181-8d0c1e5eafef": DoseUnit.Spray,
  // intrauterine device
  "9fddff20-16db-46ba-8687-c7fdde84fdaf": DoseUnit.Device,
  // mouthwash
  "161115c1-4869-4b15-8601-3d954bebf62e": DoseUnit.Application,
  // elixir
  "b901dfb6-b869-49bd-8632-dc3dbf82373a": DoseUnit.Ml,
  // eye/ear/nose drops
  "7dc71e16-c8a4-4791-96f5-b01fbb9106bf": DoseUnit.Drop,
  // dressing
  "2bff8f7f-0875-47c0-a3d9-83eddbb7d1eb": DoseUnit.Application,
  // sachet
  "7366bfef-16b0-48ca-95ec-7c247899b6aa": DoseUnit.Sachet,
  // shampoo
  "f117e52a-c47f-4266-98db-4146b496febc": DoseUnit.Application,
  // inhalation gas
  "eb9e5718-a1c4-4f72-823b-6ed5f5ba7104": DoseUnit.Application,
  // cutaneous stick
  "0a988253-95cc-4144-b790-a1fa41e6cf37": DoseUnit.Application,
  // unit
  "28e782b5-074a-487d-8cad-d1efd0258b82": DoseUnit.Unit,
  // cutaneous solution
  "7a66fd87-070f-46ad-a777-ab4801701ef2": DoseUnit.Application,
  // rectal suspension
  "8aa2d5ce-279e-4935-9255-7218385a898c": DoseUnit.Application,
  // powder for solution for injection
  "9c3c0b86-4eb1-4314-8572-75a38c6a5f89": DoseUnit.Mg,
  // solution for infusion
  "e48cc267-d61a-46bd-8985-10fb92ea77ec": DoseUnit.Mg,
  // solution
  "29f96931-3fc0-4eea-9049-42b8bedf1e55": DoseUnit.Ml,
  // oral solution
  "f20f3fd0-515d-4e38-b171-5898f3fa04c8": DoseUnit.Ml,
  // suspension for injection
  "7fd87dcc-8e9e-4e1b-9587-2c8fa1897a87": DoseUnit.Mg,
  // caustic pencil
  "e377f5fb-b5b6-448c-aec0-fdb10ef15931": DoseUnit.Application,
  // powder for oral suspension
  "5d63470d-32cb-4553-ad99-036cdf3c9654": DoseUnit.Ml,
  // solution for inhalation
  "3418d554-4107-4cef-b9b8-737ef9de89a3": DoseUnit.Application,
  // insulin solution for injection
  "c10eeca9-2e08-4550-872b-50db9be419ae": DoseUnit.Unit,
};
